import { render, staticRenderFns } from "./HeaderStyle2.vue?vue&type=template&id=d6c56c2a&scoped=true"
import script from "./HeaderStyle2.vue?vue&type=script&lang=js"
export * from "./HeaderStyle2.vue?vue&type=script&lang=js"
import style0 from "./HeaderStyle2.vue?vue&type=style&index=0&id=d6c56c2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c56c2a",
  null
  
)

export default component.exports